module.exports = __webpack_public_path__ + "img/trevor-noah.bde9ceb1.png";